import React, { useContext } from 'react';
import SectionBlock from './SectionBlock';
import { IconStarL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import { getEntriesDictionary, showSection } from '../utils';
import { skills_general as skillsOptionsGeneral } from '../../../marketplace-custom-config';
import { skills_experience as skillsExperienceOptions } from '../../../marketplace-custom-config';

const wellKnownSkills = [...skillsOptionsGeneral, ...skillsExperienceOptions].map(
    skill => skill.label
);

const skillsLabelMapper = {
    Jungpferden: 'Jungpferde',
    'Erfahrung mit Jungpferden': 'Jungpferde',
    'Unsicheren Pferden': 'Unsichere Pferde',
    'Erfahrung mit unsicheren Pferden': 'Unsichere Pferde',
    'Sensiblen Pferden': 'Sensible Pferde',
    'Erfahrung mit sensiblen Pferden': 'Sensible Pferde',
    'Temperamentvollen Pferden': 'Temperamentvolle Pferde',
    'Erfahrung mit temperamentvollen Pferden': 'Temperamentvolle Pferde',
};

const SectionSkills = () => {
    const {
        scoreData,
        categorySelected,
        horseListing,
        riderListing,
        horseImage,
        riderProfileImage,
    } = useContext(MatchingDialogContext);

    const skillSCoreNum = scoreData?.skillSCore;

    if (typeof skillSCoreNum !== 'number') return null;

    const skillSCore = { total: skillSCoreNum, maxScore: 100 };

    const { shouldBeShown } = showSection({
        categorySelected,
        ...skillSCore,
    });

    if (!shouldBeShown) return null;

    const horseListingPublicData = horseListing?.attributes?.publicData || {};
    const riderListingPublicData = riderListing?.attributes?.publicData || {};

    const horseListingSkillsGeneral = horseListingPublicData.skillsGeneral;
    const horseListingSkillsExperience = horseListingPublicData.skillsExperience;

    const riderListingSkillsGeneral = riderListingPublicData.user_skills;
    const riderListingSkillsExperience = riderListingPublicData.user_skillsExperience;

    const noHorseSkillsGeneral =
        !horseListingSkillsGeneral || horseListingSkillsGeneral.length === 0;
    const noHorseSkillsExperience =
        !horseListingSkillsExperience || horseListingSkillsExperience.length === 0;

    const filterByWellKnownSkills = skill => wellKnownSkills.includes(skill);

    const horseSkills = [
        ...(horseListingSkillsGeneral || []),
        ...(horseListingSkillsExperience || []),
    ].filter(filterByWellKnownSkills);

    const riderSkills = [
        ...(riderListingSkillsGeneral || []),
        ...(riderListingSkillsExperience || []),
    ].filter(filterByWellKnownSkills);

    if (noHorseSkillsGeneral && noHorseSkillsExperience) return null;

    const horseListingSkillsEntries = horseSkills.map(entry => ({
        entry,
        image: horseImage,
    }));

    const riderListingSkillsEntries = riderSkills.map(entry => ({
        entry,
        image: riderProfileImage,
    }));

    const entriesDictionary = [...riderListingSkillsEntries, ...horseListingSkillsEntries].reduce(
        getEntriesDictionary,
        {}
    );

    return (
        <SectionBlock scoreData={scoreData}>
            <SectionBlock.Header>
                <IconStarL />
                <span>Stärken</span>
            </SectionBlock.Header>
            <SectionBlock.ScoreBadge sectionScoreData={skillSCore} />
            <section>
                {Object.entries(entriesDictionary)
                    .sort(([_, { matches: a }], [__, { matches: b }]) => b - a)
                    .map(([entryKey, { matches, images }], index, arr) => (
                        <>
                            <SectionBlock.ScoreLine
                                key={`skills-${index}`}
                                matches={matches}
                                lineLabel={skillsLabelMapper[entryKey] || entryKey}
                                avatars={images.map((image, index) => (
                                    <SectionBlock.ScoreLineAvatar
                                        key={`skills-image-${index}`}
                                        avatarUrl={image}
                                    />
                                ))}
                            />
                            {index < arr.length - 1 && <SectionBlock.Delimiter />}
                        </>
                    ))}
            </section>
        </SectionBlock>
    );
};

export default SectionSkills;
